import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IButton} from '../../../../shared/card/card.component';
import {Order} from '../../../Models/Order';
import {BackOfficeOrderService} from '../../../Services/order.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {OrderCustomRow} from '../../../Models/OrderCustomRow';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateCustomParserFormatter} from '../../../../shared/Services/NgbDateCustomParserFormatter';
import {OrderItemProduct} from '../../../Models/OrderItemProduct';
import {OrderItem} from '../../../Models/OrderItem';
import {Option} from '../../../Models/Option';
import {OrderItemProductFabricCollection} from '../../../Models/OrderItemProductFabricCollection';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import {FabricCollection} from '../../../Models/FabricCollection';
import {Property} from '../../../Models/Property';
import {InternalPackagingLabelService} from '../../../Services/internal-packaging-label.service';
import {Discount} from '../../../Models/Discount';
import { OrderService } from 'src/app/dealer-system/Services/order.service';
import { DealersService } from 'src/app/back-office/Services/dealers.service';
import { catchError, debounceTime, distinctUntilChanged, of, Subject, switchMap, takeUntil } from 'rxjs';
import { UsersService } from 'src/app/back-office/Services/users.service';
import { AuthenticationService } from 'src/app/shared/Services/authentication.service';
import {carpetSizeLabel} from '../../../../helpers/carpet-price';

interface DiscountRequest {
  amount?: number;
  percentage?: number;
  description?: string;
}


@Component({
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
  ],
  selector: 'app-backoffice-view-quote',
  templateUrl: './backoffice-view-order.component.html',
  styleUrls: ['./backoffice-view-order.component.scss']
})
export class BackofficeViewOrderComponent implements OnInit, OnDestroy {

  constructor(
    private readonly orderService: BackOfficeOrderService,
    private readonly orderDealerService: OrderService,
    private readonly route: ActivatedRoute,
    private readonly translator: TranslateService,
    private readonly helper: Helper,
    private readonly dealersService: DealersService,
    private readonly userService: UsersService,
    public readonly auth: AuthenticationService,
    private readonly internalPackagingLabelService: InternalPackagingLabelService,
    private readonly router: Router) {
  }
  private options = [];
  @ViewChild('remarkModal', {static: false}) remarkModal = null;
  @ViewChild('orderRemarkModal', {static: false}) orderRemarkModal = null;
  @ViewChild('assignDealerModal', {static: false}) assignDealerModal = null;

  public statuses = [];
  public specialButton: IButton[] = [];
  public specialButtonArray;

  public order: Order;
  public orderId: number;
  public editCustomRow = false;
  public hasCustomRow = false;
  public orderStatus;
  public delivery;
  public remark;
  public lastOrders = [];
  public baseUrl = environment.apiUrl;
  public cloneOrderItemProducts = [];
  public cloneOrder: Order;
  public isEditableAfterCancel = true;
  public customRows: OrderCustomRow[] = [];
  public isCustomerOrder = false;
  selectedDealer;
  public dealers: any[] = [];

  private destroy$ = new Subject<void>();
  dealersTypeahead = new Subject<string>();
  @ViewChild('editOrderModal', {static: false}) editOrderModal = null;
  @ViewChild('addCustomRowModal', {static: false}) addCustomRowModal = null;
  @ViewChild('cancelModal', {static: false}) cancelModal = null;
  @ViewChild('splitModal', {static: false}) splitModal;
  @ViewChild('addCustomRowForm', {static: false}) addCustomRowForm;
  @ViewChild('notifyModal', {static: false}) notifyModal;
  @ViewChild('addressModal', {static: false}) addressModal = null;
  @ViewChild('addDiscountModal', {static: false}) addDiscountModal = null;
  @ViewChild('addDiscountForm', {static: false}) addDiscountForm;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  public discountTypeOptions = [];
  public discount = new Discount();
  public splitDiscountOn = 'both';
  public splitDiscountOptions = [];
  public isQuote = false;

  protected readonly parseInt = parseInt;
  protected readonly Discount = Discount;

  ngOnInit() {
    this.isQuote = this.route.snapshot.url[0]?.path === 'quote';;
    this.statuses.push(Order.NEW);
    this.statuses.push(Order.IN_PROCESS);
    this.statuses.push(Order.DELIVERY);
    this.statuses.push(Order.COMPLETED);
    this.statuses.push(Order.ON_HOLD);
    this.statuses.push(Order.FREE_DELIVERY_AMOUNT_NOT_REACHED);
    this.statuses.push(Order.CANCELLED);

    this.getDealers();

    this.splitDiscountOptions.push(...[
      {
        label: this.translator.instant('doctrine.backoffice.order.both'),
        value: 'both',
      },
      {
        label: this.translator.instant('doctrine.backoffice.order.current'),
        value: 'current',
      },
      {
        label: this.translator.instant('doctrine.backoffice.order.separated'),
        value: 'separated',
      }
    ]);

    this.discountTypeOptions.push(...[
      {
        label: this.translator.instant('admin.amount'),
        value: Discount.TYPE_AMOUNT
      },
      {
        label: this.translator.instant('admin.percent'),
        value: Discount.TYPE_PERCENTAGE
      }
    ]);

    const downloadCustomerPdfName = this.isQuote ? this.translator.instant('global.quote_customer_pdf') : this.translator.instant('global.order_pdf_customer')
    const downloadDealerPdfName = this.isQuote ? this.translator.instant('global.quote_dealer_pdf') : this.translator.instant('global.order_pdf_dealer')
    this.specialButtonArray = [
      {key: 'pdf', name: downloadCustomerPdfName, method: 'orderPdfCustomer', customClass: 'btn-grey'}
    ];
    if(!this.auth.isDealerUser()){
      this.specialButtonArray.push(
        {key: 'pdf', name: downloadDealerPdfName, method: 'orderPdfDealer', customClass: 'btn-grey'}
      )
    }
    if(this.isQuote){
      this.specialButtonArray.push(
        {key: 'assign', name: this.translator.instant('global.assign'), method: 'assignModal', customClass: 'btn-grey'} ,
      )
    }


    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        const request = this.isQuote ? this.orderDealerService.getQuoteOrder(this.orderId) : this.orderService.getOrder(this.orderId);
        request.subscribe((resp) => {
          this.order = resp;
          this.prepareOrder(this.order);
          this.prepareDiscount(this.order);
          if (this.order.status !== Order.CANCELLED.key) {
            this.isEditableAfterCancel = true;
            if(!this.isQuote){
              this.specialButtonArray.push({
                key: 'split_order',
                name: this.translator.instant('doctrine.order.split_order'),
                method: 'showSplitModal',
                customClass: 'btn-grey'
              });
              this.specialButtonArray.push({
                key: 'add_custome_row',
                name: this.translator.instant('doctrine.order.add_custome_row'),
                method: 'addCustomRow',
                customClass: 'btn-grey'
              });
              this.specialButtonArray.push({
                key: 'add_discount',
                name: this.translator.instant('doctrine.order.add_discount'),
                method: 'addDiscount',
                customClass: 'btn-grey'
              });
            }
            this.specialButtonArray.push({
              key: 'edit_order',
              name: this.isQuote ? this.translator.instant('global.edit_quote') :this.translator.instant('doctrine.order.edit_order'),
              method: 'goToEditOrder',
              customClass: 'btn-primary'
            });
          } else {
            this.isEditableAfterCancel = false;
          }

          // add custom fabric packaging label
          if (this.order && this.hasCustomFabric()) {
            this.specialButtonArray.unshift({
              key: 'custom_fabric_packaging_label',
              name: this.translator.instant('doctrine.order.custom_fabric_packaging_list'),
              method: 'customFabricPackagingLabel',
              customClass: 'btn-grey'
            });
          }
          // TODO: production forms has been disabled for now and only stickers available
          // check if production forms
          // if (this.order && this.order.orderItemOptions.find(item => {
          //   return item.urbanOption.hasProductionForms;
          // })) {
          //   this.specialButtonArray.unshift({
          //     key: 'production_form',
          //     name: this.translator.instant('admin.order.production_forms'),
          //     method: 'generatedProductionForm',
          //     customClass: 'btn-grey'
          //   });
          // }

          if (this.order && this.order.orderItemOptions.find(item => item.urbanOption.hasProductionForms)) {
            this.specialButtonArray.unshift({
              key: 'sticker',
              name: this.translator.instant('pdf.sticker'),
              method: 'generatedProductionForm',
              customClass: 'btn-grey'
            });
          }

          if (this.order.status !== Order.CANCELLED.key) {
            this.specialButtonArray.unshift({
              key: 'cancel_order',
              name: this.translator.instant(this.isQuote ? 'doctrine.order.cancel_quote' : 'doctrine.order.cancel_order'),
              method: 'showCancelModal',
              customClass: 'btn-grey'
            });
          }

          if (!this.isQuote && this.order.status !== Order.CANCELLED.key && this.order.status !== Order.CHANGED.key) {
            this.specialButtonArray.push(
              {key: 'service', name: this.translator.instant('global.services'), method: 'requestNewService', customClass: 'btn-grey'},
            );
          }

          this.specialButtonArray.forEach(items => {
            this.specialButton.push({
              key: items.key,
              btnName: items.name,
              btnUrl: items.btnUrl,
              method: items.method,
              btnCustomClass: items.customClass
            });
          });

          this.cloneOrder = JSON.parse(JSON.stringify(this.order));
          this.orderStatus = this.cloneOrder.status;
          // this.prepareStatus();
          this.delivery = this.cloneOrder.expectedDeliveryWeek;
          this.delivery = moment(this.delivery, 'YYYY/MM/DD');
          this.delivery = {
            'year': +this.delivery.format('YYYY'),
            'month': +this.delivery.format('M'),
            'day': +this.delivery.format('D')
          };
          // set amounts to zero
          this.cloneOrder.orderItems.forEach((orderItem, index) => {
            if (orderItem.orderItemProducts) {
              orderItem.orderItemProducts.forEach((orderItemProduct, key) => {
                this.cloneOrder.orderItems[index].orderItemProducts[key].amount = 0;
              });
            }
          });
          this.order.orderItems.forEach(orderItem => {
            if (orderItem.orderItemProducts) {
              orderItem.orderItemProducts.forEach(orderItemProduct => {
                const clone = Object.assign({}, orderItemProduct);
                this.cloneOrderItemProducts.push(clone);
              });
            }
          });
        });
      }
    });
  }

  private getDealers() {
    this.dealersTypeahead.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => {
        if (!term || !term.trim()) {
          return of([]);
        }
        return this.userService.getDealerUsersDropdown('query=' + term).pipe(
          catchError(err => {
            console.error('Error fetching dealers', err);
            return of([]);
          })
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(data => {
      this.dealers = data;
    });
  }

  getOrderItem() {
    this.orderService.getOrder(this.orderId).subscribe((resp) => {
      this.order = resp;
      if (!this.order.customRows?.length) {
        this.editCustomRow = false;
      }
      this.prepareOrder(this.order);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  requestNewService() {
    return this.router.navigateByUrl('back-office/order/' + this.orderId + '/service-request');
  }


  assignModal(){
    this.assignDealerModal.show();
  }

  assignDealer(): void{
    this.dealersService.assignDealer(this.orderId, {user_id: this.selectedDealer}).subscribe(()=> {
      this.router.navigateByUrl('back-office/quote/overview' );
      this.assignDealerModal.hide();
    })
  }

  calFunction(method: string) {
    this[method]();
  }

  editOrder() {
    this.cloneOrder = JSON.parse(JSON.stringify(this.order));
    this.orderStatus = this.cloneOrder.status;
    // this.prepareStatus();
    this.delivery = this.cloneOrder.expectedDeliveryWeek;
    this.delivery = moment(this.delivery, 'YYYY/MM/DD');
    this.delivery = {
      'year': +this.delivery.format('YYYY'),
      'month': +this.delivery.format('M'),
      'day': +this.delivery.format('D')
    };
    this.editOrderModal.show();
  }

  goToEditOrder() {
    if(this.isQuote) this.router.navigateByUrl('/back-office/quote/' + this.orderId + '/edit');
    else this.router.navigateByUrl('/back-office/order/' + this.orderId + '/edit');
  }

  manageCustomRow() {
    new Promise((resolve) => {
      if (!this.hasCustomRow && this.editCustomRow) {
        // delete this.order.orderCustomRow;
        this.orderService.deleteCustomRow(this.orderId).subscribe((res) => {
          // this.customRow.order = this.orderId;
          resolve(res);
          this.customRows = [];
        });
      } else {
        this.customRows.map(customRow => {
          delete customRow.totalPrice;
          delete customRow.orderID;
        });

        const customRequest = JSON.parse(JSON.stringify(this.customRows));
        this.orderService.addCustomRow(this.orderId, customRequest, false).subscribe((res) => {
          resolve(res);
        });
      }
    }).then((res: OrderCustomRow) => {
      this.addCustomRowModal.hide();
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(
        () => this.router.navigate(['/back-office/order/' + res.id], {replaceUrl: true}));
      // this.getOrderItem();
      // this.getAllTotal(this.order);
    });
  }

  ConfirmEditOrderInformation(order) {
    if ((order.status === Order.DELIVERY.key || order.status === Order.COMPLETED.key) &&
      (this.orderStatus === Order.NEW.key || this.orderStatus === Order.IN_PROCESS.key)) {
      this.editOrderModal.hide();
      this.notifyModal.show();
    } else {
      this.editOrderInformation(order);
    }
  }

  editOrderInformation(order) {
    let dateFrom = null;
    if (this.delivery) {
      const deliveryDate = this.delivery.year + '-' + this.delivery.month + '-' + this.delivery.day;
      const firstDayOfWeek = moment(deliveryDate, 'YYYY-MM-DD').startOf('isoWeek');
      dateFrom = firstDayOfWeek.year() + '-' + (firstDayOfWeek.month() + 1) + '-' + firstDayOfWeek.date();
    }
    const status = this.orderStatus;

    this.orderService.manageOrderInfo(dateFrom, status, order.id).subscribe(orderInfo => {
      this.order.status = orderInfo.status;
      if (orderInfo.status === Order.CANCELLED.key) {
        this.hideButtonsAfterCancelOrder();
      }
      this.order.expectedDeliveryWeek = orderInfo.expectedDeliveryWeek;
      this.editOrderModal.hide();
      this.notifyModal.hide();
    });
  }

  clearDeliveryDate() {
    this.delivery = null;
  }

  addCustomRow() {
    if (this.order.customRows && this.order.customRows.length > 0) {
      this.editCustomRow = true;
      this.hasCustomRow = true;
      this.customRows = Object.assign([], this.order.customRows);
    } else {
      this.customRows = [];
      this.customRows.push(new OrderCustomRow());
    }
    this.addCustomRowModal.show();
  }

  addNewRow() {
    this.customRows.push(new OrderCustomRow());
  }

  removeCustomRow(index) {
    this.customRows.splice(index, 1);
    this.customRows = JSON.parse(JSON.stringify(this.customRows));
  }

  resetAddCustomRow() {
    if (!this.editCustomRow) {
      this.addCustomRowForm.reset();
      this.order.customRows = [];
    }
  }

  showCancelModal() {
    this.cancelModal.show();
  }

  cancelOrder() {
    const request = this.isQuote ? this.orderDealerService.cancelQuoteOrder(this.orderId) : this.orderService.cancelOrder(this.orderId);
    request.subscribe((resp) => {
      this.hideButtonsAfterCancelOrder();
      this.cancelModal.hide();
      if(!this.isQuote) this.getOrderItem();
    });
  }

  hideButtonsAfterCancelOrder() {
    const NewSetOfSpecialButton = [];
    this.specialButton.forEach((Link) => {
      if (Link.key !== 'split_order' && Link.key !== 'edit_order' && Link.key !== 'cancel_order') {
        NewSetOfSpecialButton.push(Link);
      }
    });
    this.specialButton = NewSetOfSpecialButton;
    this.isEditableAfterCancel = false;
  }

  showSplitModal() {
    this.splitModal.show();
  }

  splitOrder() {
    this.cloneOrder.splitDiscountOn = this.splitDiscountOn;
    this.orderService.splitOrder(this.cloneOrder).subscribe(res => {
      if (res) {
        this.splitModal.hide();
        this.router.navigateByUrl('/back-office/order/overview');
      }
    });
  }

  /**
   * An article's subtotal is by definition the sum of its lines, so it is DERIVED from the
   * line totals rather than accumulated alongside them (POS-D02). The previous form kept a
   * running total that each new priced thing had to be added to by hand, in the right
   * branch: the package branch re-added `productPrice` on every package product, so an
   * article with a package showed twice the product's price in its subtotal while the order
   * total - built from the same line totals - stayed correct. That is the whole defect
   * class, and every feature that adds a priced line reopened it.
   *
   * One term per line the article renders, mirroring the same split in the dealer portal's
   * view-order screen so the two can never drift.
   */
  getAllTotal(order: Order) {
    if (!Helper.isDefined(order.orderItems)) {
      return;
    }

    order.orderItems.forEach((orderItem) => {
      orderItem.totalArticleDealerPrice = orderItem.orderItemProducts.reduce(
        (total, orderItemProduct) => Helper.bcAdd(
          total,
          this.productLineTotal(orderItemProduct),
          this.fabricLineTotal(orderItemProduct),
          this.packageLineTotal(orderItemProduct),
          this.optionsLineTotal(orderItem, orderItemProduct),
        ),
        0,
      );
    });
  }

  /**
   * The product row's own total. Deliberately the stored line total rather than the
   * material-only figure carpetLineTotal() displays: a rug's Shape/Finishing are already
   * inside it, which is why optionSubtreeTotal() skips those option rows.
   */
  private productLineTotal(orderItemProduct): number {
    return +(this.isCustomerOrder
      ? orderItemProduct.totalCost.totalCustomerCost
      : orderItemProduct.totalCost.totalDealerPrice) || 0;
  }

  private fabricLineTotal(orderItemProduct): number {
    const fabric = orderItemProduct.orderItemProductFabricCollections?.[0];
    if (!fabric) {
      return 0;
    }

    return +(this.isCustomerOrder ? fabric.totalCost.totalCustomerCost : fabric.totalCost.totalDealerPrice) || 0;
  }

  private packageLineTotal(orderItemProduct): number {
    return (orderItemProduct.orderItemProductPackages ?? []).reduce(
      (total, orderItemProductPackage) => orderItemProductPackage.orderItemProductPackageProducts.reduce(
        (packageTotal, packageProduct) => Helper.bcAdd(
          packageTotal,
          +(this.isCustomerOrder
            ? packageProduct.totalCost.totalCustomerCost
            : packageProduct.totalCost.totalDealerPrice) || 0,
        ),
        total,
      ),
      0,
    );
  }

  private optionsLineTotal(orderItem: OrderItem, orderItemProduct): number {
    return (this.calculateOptions(orderItem, orderItemProduct) ?? []).reduce(
      (total, option) => Helper.bcAdd(total, this.optionSubtreeTotal(option, orderItemProduct)),
      0,
    );
  }

  orderPdfCustomer() {
    this.orderService.getPdf(this.orderId, 'customer').subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  orderPdfDealer() {
    this.orderService.getPdf(this.orderId, 'dealer').subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  customFabricPackagingLabel() {
    this.orderService.getCustomFabricPackagingPdf(this.orderId).subscribe((resp) => {

    });
  }


  /**
   * Rugs are the only line that carries dimensions — a sofa leaves widthCm/lengthCm
   * null — so the label doubles as the "is this a carpet" test and returns null for
   * everything else, which interpolates to nothing.
   */
  carpetSizeLabel = carpetSizeLabel;

  calculateOptions(orderItem: OrderItem, orderItemProduct: OrderItemProduct) {
    const productOptions = this.options[orderItemProduct.id];
    if (Helper.isDefined(productOptions)) {
      return productOptions;
    }
  }

  getMaxAmount(orderItemProduct) {
    const originalOrderItemProduct = this.cloneOrderItemProducts.filter(item => item.id === orderItemProduct.id)[0];
    return originalOrderItemProduct.amount;
  }

  getMinAmount() {
    return this.cloneOrderItemProducts.length === 1 ? 1 : 0;
  }

  checkSplitIsDisabled() {
    let disable = false;
    const orderItemProducts = [];
    this.cloneOrder.orderItems.forEach(item => {
      if (item.orderItemProducts) {
        item.orderItemProducts.forEach(orderItemProduct => {
          orderItemProducts.push(orderItemProduct);
        });
      }
    });
    let totalAmounts = 0;
    const diff = orderItemProducts.filter(item => (
      !this.cloneOrderItemProducts.some(original => (original.id === item.id && original.amount === item.amount)))
    );
    // If the new order is same as original order we can't split order
    if (diff.length === 0) {
      disable = true;
    }
    orderItemProducts.forEach(item => {
      if (item.amount > this.getMaxAmount(item)) {
        disable = true;
      }
      totalAmounts += +item.amount;
    });
    // If all amounts in new order was 0 so we can't split the order
    if (totalAmounts === 0) {
      disable = true;
    }
    return disable;
  }

  cancelSplit() {
    this.cloneOrder.orderItems.forEach(orderItem => {
      orderItem.orderItemProducts.forEach(orderItemProduct => {
        orderItemProduct = this.cloneOrderItemProducts.filter(item => item.id === orderItemProduct.id)[0];
      });
    });
    this.splitModal.hide();
  }

  lastOrderCalc(order: Order) {
    if (order.lastOrder) {
      if (this.lastOrders.findIndex(lastOrder => order.lastOrder.id === lastOrder.id) === -1) {
        this.lastOrders.push(order.lastOrder);
      }
      this.prepareOrder(order.lastOrder);
      this.lastOrders = Object.values(this.lastOrders);
    }
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null)
    || (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabricName  && orderItemProductFabricCollection.fabricColorName)
      ;
  }

  checkType(option) {
    return (!option.children || option.type === Option.OPTION_TYPE_SELECT);
  }

  /**
   * An option is shown inline (comma separated, on its parent's line) when its own `parent`
   * label is the parent option's selected value; otherwise it starts its own labelled line.
   * Same rule as the API report template, see the #optionCell template.
   */
  isInlineOption(option, parentCurrent): boolean {
    return !!parentCurrent && option.parent === parentCurrent;
  }

  /**
   * An option's price for the article subtotal is the sum of the option rows the template
   * actually prices, walked over the whole subtree: nested options such as a pillow under
   * "Contrast piping" or a leg size under "Different legs" carry the price on their own row.
   * checkType() is the same gate the Price and Total columns use, and it blanks a non-Select
   * option that has children, because that parent's own charge is already inside its child's
   * stored total -- so a row whose total is not shown must not be added either.
   *
   * Deliberately NOT the server's cumulativeTotal*Price: OrderService::generateOptionStructure()
   * adds a top-level Select's own total to its cumulative a second time, so every such option
   * arrives doubled (order 213773's POS line: totalDealerPrice 25.00, cumulative 50.00, which
   * put the article subtotal 25.00 above the order total). The order PDF reads the same field
   * and is wrong in the same way -- that needs fixing server-side.
   *
   * A rug's Shape/Finishing/Colour options are skipped, because their price is already folded
   * into the rug line's own total.
   */

  private optionSubtreeTotal(option, orderItemProduct): number {
    if (!this.isCalculatable(orderItemProduct) || option.carpetRole) {
      return 0;
    }
    const ownRow = this.checkType(option)
      ? parseFloat(this.isCustomerOrder ? option.totalCustomerPrice : option.totalDealerPrice) || 0
      : 0;

    return (option.children ?? []).reduce(
      (total, child) => Helper.bcAdd(total, this.optionSubtreeTotal(child, orderItemProduct)),
      ownRow,
    );
  }

  private fixCustomFabrics(order: Order) {
    order.orderItems.forEach(orderItem => {
      let lastCustomFabric: OrderItemProductFabricCollection | null = null;
      orderItem.orderItemProducts.forEach((orderItemProduct) => {
        const fabric = orderItemProduct.orderItemProductFabricCollections?.[0];
        if (fabric && (fabric.fabricCollection as FabricCollection)?.isCustom) {
          if (fabric.fabricName || fabric.fabricColorName) {
            lastCustomFabric = fabric;
          }
          if (lastCustomFabric) {
            fabric.fabricName = lastCustomFabric.fabricName;
            fabric.fabricColorName = lastCustomFabric.fabricColorName;
          }
        }
      });
    });
  }

  private prepareOrder(order) {
    this.fixCustomFabrics(order);
    // Indexed by ELEMENT (orderItemProduct id) below, so a quote must be asked for the
    // per-element shape as well. The quote endpoint's default is keyed by article with the
    // elements' options merged, so every lookup here missed and a quote showed no options
    // at all -- or, where an element id happened to equal an article id, that article's
    // whole merged list under one element (US-604 C7).
    const request = this.isQuote
      ? this.orderDealerService.getQuoteOption(order.id, true)
      : this.orderService.getOption(order.id);
    request.subscribe(orderItemOptions => {
      order.orderItems.forEach((orderItem) => {
        orderItem.orderItemProducts.forEach((orderItemProduct) => {
          const orderItemProductId = orderItemProduct.id;
          if (orderItemOptions[orderItemProductId] == null) {
            this.options[orderItemProductId] = [];
          } else {
            this.options[orderItemProduct] = [];
            Object.keys(orderItemOptions[orderItemProductId]).forEach(productId => {
              this.options[orderItemProductId] = orderItemOptions[orderItemProductId];
            });
          }
        });
      });
      this.isCustomerOrder = this.order.user.isCustomerAccount;
      this.lastOrderCalc(order);
      this.getAllTotal(order);
    });
  }

  getOrderAllowStatusTranslation(allowPartial) {
    if (allowPartial) {
      if (allowPartial === Order.PARTIAL_ORDER_ALLOW) {
        return this.translator.instant('doctrine.backoffice.order.allow_partial_order_description');
      } else {
        return this.translator.instant('doctrine.backoffice.order.not_allow_partial_order_description');
      }
    }
  }

  checkAllowPartialOrder(order) {
    return order.allowPartial === Order.PARTIAL_ORDER_ALLOW && order.parentId > 0;
  }

  isDisabled = (disabled, customDate: NgbDate, currentMonth) => customDate.month !== currentMonth || disabled;

  isWeekSelected(customDate: NgbDate) {
    if (!this.delivery) {
      return false;
    }
    const dateString = this.delivery.year + '-' + this.delivery.month + '-' + this.delivery.day;
    const firstDayOfWeek = moment(dateString, 'YYYY-MM-DD').startOf('isoWeek');
    const secondDayOfWeek = moment(firstDayOfWeek).add(1, 'days');
    const thirdDayOfWeek = moment(firstDayOfWeek).add(2, 'days');
    const forthDayOfWeek = moment(firstDayOfWeek).add(3, 'days');
    const fifthDayOfWeek = moment(firstDayOfWeek).add(4, 'days');
    const sixDayOfWeek = moment(firstDayOfWeek).add(5, 'days');
    const endDayOfWeek = moment(firstDayOfWeek).add(6, 'days');
    return (customDate.day === firstDayOfWeek.date() && (customDate.month === firstDayOfWeek.month() + 1) && customDate.year === firstDayOfWeek.year()) ||
      (customDate.day === secondDayOfWeek.date() && (customDate.month === secondDayOfWeek.month() + 1) && customDate.year === secondDayOfWeek.year()) ||
      (customDate.day === thirdDayOfWeek.date() && (customDate.month === thirdDayOfWeek.month() + 1) && customDate.year === thirdDayOfWeek.year()) ||
      (customDate.day === forthDayOfWeek.date() && (customDate.month === forthDayOfWeek.month() + 1) && customDate.year === forthDayOfWeek.year()) ||
      (customDate.day === fifthDayOfWeek.date() && (customDate.month === fifthDayOfWeek.month() + 1) && customDate.year === fifthDayOfWeek.year()) ||
      (customDate.day === sixDayOfWeek.date() && (customDate.month === sixDayOfWeek.month() + 1) && customDate.year === sixDayOfWeek.year()) ||
      (customDate.day === endDayOfWeek.date() && (customDate.month === endDayOfWeek.month() + 1) && customDate.year === endDayOfWeek.year());
  }

  hasCustomFabric() {
    return this.order.orderItems.some(orderItem =>
      orderItem.orderItemProducts.some(orderItemProduct =>
        !!(orderItemProduct.orderItemProductFabricCollections[0].fabricCollection as FabricCollection)?.isCustom
      )
    );
  }

  getFontAwesomeIconFromMIME(mimeType) {
    const icon_classes = {
      // Media
      image: 'fa-file-image-o',
      audio: 'fa-file-audio-o',
      video: 'fa-file-video-o',
      // Documents
      'application/pdf': 'fa-file-pdf-o',
      'application/msword': 'fa-file-word-o',
      'application/vnd.ms-word': 'fa-file-word-o',
      'application/vnd.oasis.opendocument.text': 'fa-file-word-o',
      'application/vnd.openxmlformats-officedocument.wordprocessingml':
        'fa-file-word-o',
      'application/vnd.ms-excel': 'fa-file-excel-o',
      'application/vnd.openxmlformats-officedocument.spreadsheetml':
        'fa-file-excel-o',
      'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel-o',
      'application/vnd.ms-powerpoint': 'fa-file-powerpoint-o',
      'application/vnd.openxmlformats-officedocument.presentationml':
        'fa-file-powerpoint-o',
      'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint-o',
      'text/plain': 'fa-file-text-o',
      'text/html': 'fa-file-code-o',
      'application/json': 'fa-file-code-o',
      // Archives
      'application/gzip': 'fa-file-archive-o',
      'application/zip': 'fa-file-archive-o'
    };

    for (const key in icon_classes) {
      if (icon_classes.hasOwnProperty(key)) {
        if (mimeType.search(key) === 0) {
          return icon_classes[key];
        }
      } else {
        return 'fa-file-o';
      }
    }
  }

  isCustomFabric(orderItemProductFabricCollection) {
    return !!orderItemProductFabricCollection.fabricCollection?.isCustom;
  }

  public isCalculatable(orderItemProduct) {
    const option = orderItemProduct.selectedPerProductOption ? orderItemProduct.selectedPerProductOption.urbanOption : null;
    return !(this.isCustomFabric(orderItemProduct.orderItemProductFabricCollections[0]) && option && option.needsFabric) ||
      !this.isCustomFabric(orderItemProduct.orderItemProductFabricCollections[0]);
  }

  public recalculateFabricAmount(orderItemProductFabricCollections, selectedOption, productAmount, orderItemProduct: OrderItemProduct) {
    let fabricAmount = 0;
    const productProperty = typeof orderItemProduct.product === 'object' ? orderItemProduct.product.productProperties.find(item => item.property.code === Property.PROPERTY_FABRIC_STOFVERRUIK) : null;
    if (productProperty) {
      fabricAmount = Number((parseFloat(productProperty.amount) * orderItemProduct.amount).toFixed(2));
    } else {
      fabricAmount = orderItemProductFabricCollections.amount;
    }

    fabricAmount += .25;
    if ( selectedOption && selectedOption.needsFabric && selectedOption.fabricAmount ) {
      fabricAmount +=  productAmount * Number(selectedOption.fabricAmount);
    }
    return fabricAmount;
  }

  openAddressModal() {
    this.addressModal.show();
  }

  updateAddress() {
    const customerDeliveryAddress = this.order.customerDeliveryAddress;
    const id = this.order.customerDeliveryAddress.id;
    delete customerDeliveryAddress.id;
    this.orderService.updateCustomerDeliveryAddress(customerDeliveryAddress, id).subscribe((resp) => {
      this.order.customerDeliveryAddress = resp;
      this.addressModal.hide();
      this.helper.popMessageDialog(
        this.translator.instant('global.success_message.title'),
        this.translator.instant('global.success_message.description'),
        'success',
        false
      );
    });
  }

  generatedProductionForm() {
    this.internalPackagingLabelService.generateSingleProductionForms(this.order.id).subscribe();
  }

  addDiscount() {
    this.addDiscountModal.show();
  }
  changeDiscount(event) {
    this.discount.amount = 0.0;
    this.discount.percentage = 0.0;
    this.discount.type = event.value;
    this.discount.applied = 0.0;
  }
  manageDiscount(): void {
    this.checkDiscountValidation();
    const discountRequest = this.createDiscountRequest();

    if (this.hasDiscountChanges(discountRequest)) {
      this.applyDiscountAndNavigate(discountRequest);
    } else {
      this.addDiscountModal.hide();
    }
  }

  removeDiscount() {
    this.orderService.deleteDiscount(this.orderId).subscribe((res: any) => {
      this.addDiscountModal.hide();
      const orderPath = `/back-office/order/${res.id}`;
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([orderPath], {replaceUrl: true}));
    });
  }

  private checkDiscountValidation() {
    const totalPrice =  Helper.bcAdd(this.findDiscountablePrice(), this.order.discount.applied);
    if (this.discount.type === Discount.TYPE_AMOUNT &&  this.discount.amount > totalPrice) {
      this.discount.amount = totalPrice;
      this.discount.castIt(
        totalPrice,
        totalPrice
      );
    }
  }

  private findDiscountablePrice(): number {
    return this.order.user.isCustomerAccount ?
      this.order.totalCost.totalCustomerCost  : this.order.totalCost.totalDealerPrice;
  }

  private createDiscountRequest(): DiscountRequest {
    const request: DiscountRequest = {};

    if (this.discount.type === Discount.TYPE_AMOUNT &&
      this.order.discount.amount !== this.discount.amount) {
      request.amount = this.discount.amount;
    }

    if (this.discount.type === Discount.TYPE_PERCENTAGE &&
      this.order.discount.percentage !== this.discount.percentage) {
      request.percentage = this.discount.percentage;
    }

    request.description = this.discount.description;

    return request;
  }

  private hasDiscountChanges(request: DiscountRequest): boolean {
    return request.percentage !== undefined || request.amount !== undefined;
  }

  private applyDiscountAndNavigate(request: DiscountRequest): void {
    this.orderService.addDiscount(this.orderId, request).subscribe((res) => {
      this.addCustomRowModal.hide();
      const orderPath = `/back-office/order/${res.id}`;
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([orderPath], {replaceUrl: true}));
    });
  }

  castDiscount(value) {
    this.discount.castIt(Helper.bcAdd(this.findDiscountablePrice(), this.order.discount.applied), value);
  }

  private prepareDiscount(order: Order) {
    this.discount.amount = order.discount.amount;
    this.discount.percentage = order.discount.percentage;
    this.discount.description = order.discount.description;
    this.discount.type = order.discount.amount > 0 ? 'amount' : 'percent';
    this.discount.castIt(
      Helper.bcAdd(this.findDiscountablePrice(), this.order.discount.applied),
      order.discount.amount > 0 ?
        order.discount.amount : order.discount.percentage
    );
  }

  /**
   * A carpet line's product row shows the rug's MATERIAL amount, in whichever price scope
   * is on: shape and finishing render their own rows underneath it, so repeating the
   * combined line total there reads as if the rug itself cost the whole line.
   *
   * `unit` is derived rather than served separately - it differs from the total only by the
   * line's amount, since every option total is its own per-unit cost times that amount.
   * A sofa line, or a carpet line whose stored total is unusable, has no material figure
   * and falls back to exactly what it shows today.
   */
  carpetUnitPrice(orderItemProduct): number {
    const material = this.isCustomerOrder
      ? orderItemProduct.carpetMaterialCustomerPrice
      : orderItemProduct.carpetMaterialPrice;
    if (material === undefined || material === null) {
      return this.isCustomerOrder ? orderItemProduct.cost.customerPrice : orderItemProduct.cost.dealerPrice;
    }
    const amount = orderItemProduct.amount > 0 ? orderItemProduct.amount : 1;

    return material / amount;
  }

  /** The same figure as a line total - what the row's Total column shows. */
  carpetLineTotal(orderItemProduct): number {
    const material = this.isCustomerOrder
      ? orderItemProduct.carpetMaterialCustomerPrice
      : orderItemProduct.carpetMaterialPrice;
    if (material === undefined || material === null) {
      return this.isCustomerOrder ? orderItemProduct.totalCost.totalCustomerCost : orderItemProduct.totalCost.totalDealerPrice;
    }

    return material;
  }
}
